import React from "react";
import { useTranslation } from 'react-i18next';

export default function AlreadyTakenView(props) {
    var convertDateFormat = props.startDate
    console.log(convertDateFormat)
    var expireDate = (new Date(convertDateFormat)).toLocaleString();  
    return(
        <div className="limiter">
            <div className="container h-vh pl-0 pr-0">
                <div className="row justify-content-center h-100 ml-0 mr-0">
                    <div className="col-md-7 pl-0 pr-0">
                        <div className="logo-container text-center confirm"><img src={require('../assets/images/logo_white.svg')} alt=""/></div>
                            <div className="card">
                                <div className="card-body text-center">
                                    <h5 className="card-header text-white bg-danger text-uppercase text-center">
                                        {props.sheetData.FreeRegAlreadyUsedPartA} <strong style={{textDecoration: 'underline'}}>{props.visitorPassModel.PlateNo}</strong>  {props.sheetData.FreeRegAlreadyUsedPartB}
                                    </h5>
                                    <h5 className="card-title"><i><img src={require('../assets/images/clock.svg')} alt=""/></i>
                                    {!props.isFreeHourExpired && <span>
                                        {props.sheetData.YourFreePakingExpiresAt}
                                    </span> }
                                    {props.isFreeHourExpired && <span>
                                        {props.sheetData.YourFreePakingExpiredAt}
                                    </span> }
                                    </h5>
                                    <div className="start-end-time">
                                        <span><strong className="start">
                                            {expireDate}                                        
                                        </strong></span>                                    
                                    </div>
                                    <hr/>
                                    <p className="card-text">{props.sheetData.Zone} <strong>{props.visitorPassConfirmation.ParkingZone}</strong></p>
                                    <p className="download mt-4 mb-4">{props.sheetData.DownloadBlinkayForEase}</p>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <button type="button" className="btn btn-primary download w-100" onClick= {()=>{props.resetForm()}}>{props.sheetData.Reset}</button>
                                        </div>
                                        <div className="col-md-6">
                                            {!props.isIOS && <button className="w-100"><a href="https://play.google.com/store/apps/details?id=com.integrapark.iparkmerel&hl=en_US"  className="btn btn-primary download w-100">{props.sheetData.DownloadBlinkayButton}</a></button>}
                                            {props.isIOS && <button><a href="https://apps.apple.com/ca/app/blinkay-iparkme/id958170386" className="btn btn-primary download w-100">{props.sheetData.DownloadBlinkayButton}</a></button>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="copyright mt-5 text-center text-uppercase"><a href = "https://blinkay.com/">© Blinkay</a> {(new Date().getFullYear())}. {props.sheetData.AllRightReserved}</div>
                    </div>
                </div>
            </div>
        </div>
    )    
}